<template>
  <div>
    <el-button class="el-icon-edit" @click="dialogVisible = true"
      >节点奖励百分比</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="节点奖励百分比设置"
      width="1000px"
      @close="closeDialog"
    >
      <div class="star">
        <el-form ref="form" label-width="100px">
          <el-form-item label="繁星计划：">
            <mutiple-input v-model="newStar" />
          </el-form-item>
        </el-form>
      </div>
      <div class="star">
        <el-form ref="form" label-width="100px">
          <el-form-item label="星空计划：">
            <mutiple-input v-model="starrySky" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import MutipleInput from '../mutipleInput';

export default {
  name: 'foundationCreate',
  data() {
    return {
      dialogVisible: false,
      newStar: [],
      starrySky: []
    };
  },
  components: {
    MutipleInput
  },
  computed: {},
  methods: {
    ...mapActions('foundationProject', ['setPercent', 'getpercent']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {
        distributionCoinType: 'FBS'
      };
      this.$refs['form'].resetFields();
    },
    handleSave() {
      const newStarData =
        this.newStar &&
        this.newStar.reduce(
          (obj, item) => ({ ...obj, [item.key]: item.value }),
          {}
        );
      const starrySkyData =
        this.starrySky &&
        this.starrySky.reduce(
          (obj, item) => ({ ...obj, [item.key]: item.value }),
          {}
        );
      this.setPercent({ newStar: newStarData, starrySky: starrySkyData })
        .then(() => {
          this.$message({
            message: '操作成功!',
            type: 'success'
          });
        })
        .finally(() => {
          this.dialogVisible = false;
        });
    }
  },
  created() {
    this.getpercent().then(res => {
      this.newStar = Object.keys(res.data.newStar).map(key => ({
        key,
        value: res.data.newStar[key]
      }));
      this.starrySky = Object.keys(res.data.starrySky).map(key => ({
        key,
        value: res.data.starrySky[key]
      }));
    });
  }
};
</script>

<style lang="less"></style>
